import { Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DataGridProps, GridToolbar, DataGrid as MuiDataGrid } from '@mui/x-data-grid';

const StyledDataGrid: typeof MuiDataGrid = styled(MuiDataGrid)(({ theme }: { theme: Theme }) => ({
  'border': 'none',
  '& .MuiDataGrid-footerContainer': {
    border: 'none'
  },
  '& .MuiDataGrid-columnHeaders': {
    background: theme.palette.grey[200],
    borderBottom: 'unset'
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    // color: 'var(--primary)',
    color: theme.palette.grey[800],
    fontWeight: 500,
    textTransform: 'uppercase',
    flex: 'none'
  },
  '& .MuiDataGrid-cell': {
    'borderColor': theme.palette.divider,
    'color': theme.palette.info.main,
    '&.link': {
      color: theme.palette.primary.main,
      fontWeight: 500,
      cursor: 'pointer'
    }
  },
  '& .MuiDataGrid-cellContent': {
    // color: 'inherit'
    // fontWeight: 700
    color: theme.palette.primary.dark,
    cursor: 'pointer'
  },
  '& .MuiTextField-root': {
    // minWidth: 300
  },
  '& .MuiDataGrid-row:nth-child(even)': {
    background: theme.palette.background.default
  },
  '& .MuiDataGrid-overlayWrapper': {
    minHeight: 48
  }
}));

const DataGrid = <T extends { id: number }>({ columns, rows, ...p }: DataGridProps<T>) => (
  <StyledDataGrid
    disableColumnMenu
    slots={{ toolbar: GridToolbar }}
    slotProps={{
      toolbar: {
        showQuickFilter: true,
        filter: { filterModel: { quickFilterExcludeHiddenColumns: true } }
      }
    }}
    getRowId={({ id }: T) => id}
    columns={columns}
    rows={rows}
    {...p}
  />
);

export default DataGrid;
